import { TeamFilters } from '@/interfaces/filters/teamFilters';
import { Team } from '@/interfaces/team';
import { teamResource, TeamResource } from '@/resources/team.resource';
import { EntityModule } from './entity.module';
import coach from './team/coach.module';
import player from './team/player.module';

/**
 * Moduł grup treningowych
 *
 * @export
 * @class TeamModule
 * @extends {EntityModule<Team, TeamResource>}
 */
export class TeamModule extends EntityModule<Team, TeamResource> {
  public modules = { coach, player };

  constructor() {
    super(teamResource);

    const superList = this.actions.list;

    this.actions = {
      ...this.actions,
      /**
       * Pobiera listę encji
       *
       * @param context context
       * @param filters filtry listy
       */
      list: (context: any, filters: TeamFilters): Promise<void> => {
        filters.clubId = context.rootState.club.id;
        return superList(context, filters);
      },
      /**
       * Aktualizuje encję
       *
       * @param context context
       * @param data dane encji
       */
      update: async (context: any, data: Team): Promise<void> => {
        const teamId = await this.resource.update(data.id as number, data);
        context.dispatch('get', teamId);
        context.commit('update', data);
      }
    };
  }
}

export default new TeamModule();
